module.exports = __webpack_public_path__ + "static/media/11-EntreVestors.598d53b4.png";